import MD5 from "js-md5";  //导入
import { ElMessage } from 'element-plus';
function placeholderPic(){
	document.documentElement.style.fontSize=document.documentElement.offsetWidth/60+"px"; //同上
}
function isLogin(){
	var isLogin = localStorage.getItem('isLogin');
	if(isLogin){
		return true;
	}else{
		return false;
	}
}
function platForm(){
	var u = navigator.userAgent;
	var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
	var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
	var platForm = 'pc';
	if(isAndroid){
	    console.log("android");
		platForm = 'android';
	}else if(isIOS){
		platForm = 'ios';
	    console.log("ios");
	}
	return platForm;
	
}
/**
 * 判断是否为合法的身份证号码
 */
function isCard(card){
	var regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; 
	if(card.length!=18){
		return {rt:false,msg:'身份证长度18位！'}; 
	}
	if(!regIdNo.test(card)){ 
	  return {rt:false,msg:'身份证格式格式！'}; 
	}
	return {rt:true,msg:'身份证验证通过！'};
}
function isWx(){//是否微信
	var ua = window.navigator.userAgent.toLowerCase();
	 if (ua.match(/MicroMessenger/i) == 'micromessenger') {
	     console.log("微信");
		 return true;
	 } else {
	     console.log("非微信");
		 return false;
	 }
}
function isToday(timestamp) {
    // 将秒级时间戳转换为毫秒级
    const date = new Date(timestamp * 1000);
    const today = new Date();
    
    // 比较年、月、日是否相同
    return date.getFullYear() === today.getFullYear() &&
           date.getMonth() === today.getMonth() &&
           date.getDate() === today.getDate();
}
function clearLogin(){//清除登录信息
	localStorage.removeItem('isLogin');
	localStorage.removeItem('userInfo');
	localStorage.removeItem('comebackTip');
	localStorage.removeItem('audioMp3Tip');
	localStorage.removeItem('appointmentAutoTip');
	//location.reload();
	console.log('清除登录信息')	
	
}
function networkError(error){
	//console.log('networkError',error);
	if(error=='ERR_NETWORK' || (error.msg && error.msg.page=='/login')){
		this.clearLogin();
		window.location.href = '/login';
	}
}
//禁止多次弹出提示
function noManyMsg(msg){
	var isMsg = localStorage.getItem('isMsg');
	if(!isMsg){
		localStorage.setItem('isMsg',true);
		setTimeout(function(){
			localStorage.clear('isMsg');
			window.location.href = '/login'; // 直接改变URL地址到/about页面
		},500);
		ElMessage.error({offset:window.screen.height/2.5,message:msg});
	}
}
/**
 * @desc 防抖函数
 * @param fn 目标函数
 * @param wait 延迟执行毫秒数
*/
function debounce (fn, wait = 1000) {
	let timer = null;
	return function () {
		let now = !timer;
		timer && clearTimeout(timer);
		timer = setTimeout(() => {timer = null;}, wait);
		if (now) {
			fn.apply(this, arguments);
		}
    };
}
/**
 * @desc 节流函数
 * @param fn 目标函数
 * @param wait 延迟执行毫秒数
*/
function throttle (fn, wait = 1000) {
	let last = 0;
	return function () {
		let now = Date.now();
		if (now - last > wait) {
			fn.apply(this, arguments);
			last = now;
        }
    };
}
function getSign(param) {  // 获取签名   返回一个包含"?"的参数串
    var appKey = "Mr.whSDI2HHFL90.FSWW3E1Q";
    var securityKey = "2022sbkj96CD09FGJCd8k";
    var timeStamp = Date.parse(new Date())/1000;
	
    // 判断是否有参数
    if(param!=null && param.length>0) {
        param = "appKey=" + appKey + "&timeStamp=" + timeStamp + "&" + param;
    }else {
        param = "appKey=" + appKey + "&timeStamp=" + timeStamp;
    }
	var sign = calculateSign(param,securityKey);
    return sign+'#$!'+timeStamp; 
	//return "?appKey="+appKey+"&timeStamp="+timeStamp+"&sign="+calculateSign(param,securityKey); 
}
// 生成sign
function calculateSign(param,securityKey) {
    var params = param.split("&");
	//剔除数组参数start
	var newParams = [];
	var len = params.length;
	if(len>0){
		var reg = new RegExp("^(.*)%5B(.*)%5D(.*)=(.*)$",'i');
		for(var i=0;i<len;i++){
			
			if(!reg.test(params[i])){
				var paramsDecode = decodeURIComponent(params[i]);
				params[i] = paramsDecode.length>2048 ? '' : paramsDecode;
				newParams.push(params[i])
			}
		}
		params = newParams;
	}
	//剔除数组参数end
	var regex = new RegExp("[\\s \\@/:%#^$&*]",'g');
	param = (params.sort().join("&")).replace(regex,""); 
	return (MD5(param+securityKey)).toUpperCase(); 
}
// 生成指定长度的随机字符串
function randStr(length = 12) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}
//获取当前时间戳
function getTime() {
    return new Date().getTime();
}
function permissions(data,id) {
    for (let i = 0; i < data.length; i++) {
        const oItem = data[i];
        if (oItem.menu_id === id) {
            return oItem.children;
        }else{
			//console.log('data[i]',data[i]);
            if (oItem.children && oItem.children.length) {
                const result = permissions(oItem.children,id);
                if (result) {
                    return result;
                }
            }
        }
    }
}
function menuBtns(data,id){
	var permissions = this.permissions(data,id);
	//console.log('permissions',permissions);
	var menuBtns = [];
	var len = permissions?permissions.length:0;
	if(len>0){
		for(var i=0;i<len;i++){
			if(!permissions[i].children){
				//var params = permissions[i].path.split('/');
				var params = permissions[i].path;
				if(menuBtns.indexOf(params) == -1){
					menuBtns.push(params);
				}
			}	
		}
	}
	return menuBtns;
}
function menuTabs(data,id){
	var permissions = this.permissions(data,id);
	//console.log('permissions',permissions);
	var menuTabs = [];
	var len = permissions?permissions.length:0;
	if(len>0){
		for(var i=0;i<len;i++){
			if( permissions[i].menu_type==1){
				var params = permissions[i].path;
				//console.log('params',params);
				if(menuTabs.indexOf(params) == -1){
					menuTabs.push(permissions[i]);
				}
			}
		}
	}
	return menuTabs;
}
//数组合并去重
function mergeAndDistinct(arr1, arr2) {
  let merged = arr1.concat(arr2);
  let distinct = Array.from(new Set(merged));
  return distinct;
}
//搜索菜单中有无某个值
function findMenuId(routes, targetId) {
  for (let route of routes) {
    // 检查当前节点的 menu_id
    if (route.menu_id === targetId) {
      return true;
    }
    // 如果存在子节点，递归检查
    if (route.children && route.children.length > 0) {
      const foundInChildren = findMenuId(route.children, targetId);
      if (foundInChildren) {
        return true;
      }
    }
  }
  return false;
}
//返回二个数组的重复项
function findDuplicates(arr1, arr2) {
	const set2 = new Set(arr2);
	return arr1 && arr2 ? arr1.filter(item => set2.has(item)) : [];
}
//根据ids的值，获取对应的name值，生成数组
function getNamesByIds(ids,cityOptions) {
    return cityOptions.flatMap(group => 
        group.cityList
            .filter(city => ids.includes(city.id))
            .map(city => city.name)
    );
}
//匹配正整数或保留一位小数的数字
function validateStrictNumber(input) {
  // 更严格的验证：
  // - 允许 0
  // - 允许正整数
  // - 允许带一位小数的数字
  // - 不允许 01, 00 这样的数字
  const pattern = /^(0|[1-9]\d*)(\.\d{1})?$/;
  return pattern.test(input);
}
// 更严格的正则验证函数：
// - 大于0
// - 允许正整数
// - 不允许带小数的数字
// - 不允许 01, 00 这样的数字
function strictPositiveIntegerValidator(value) {
  // 正则解释：
  // ^[1-9]：以1-9开头，确保不是0开头且大于0
  // [0-9]*$：后面可以跟0个或多个0-9的数字
  const regex = /^[1-9][0-9]*$/;
  
  // 如果输入是数字类型，先转换为字符串
  const strValue = String(value);
  
  // 空值检查
  if (strValue === '' || strValue === null || strValue === undefined) {
    return false;
  }
  
  return regex.test(strValue);
}
//取整加一
function roundAndCeilIfDecimal(num) {
    let floored = Math.floor(num);
    if (floored !== num) {
        return Math.ceil(num);
    }
    return floored;
}
/**
 * 判断目标是否为 undefined（含未声明、值为 undefined、'undefined' 字符串）
 * @param {*} target 待判断的变量/值
 * @param {boolean} includeStr 是否把 'undefined' 字符串视为 undefined（默认 true）
 * @returns {boolean}
 */
function isUndefined(target, includeStr = true) {
  // 处理：未声明变量 或 已声明但值为 undefined
  const isRawUndefined = typeof target === 'undefined';
  
  // 处理：值为 'undefined' 字符串的情况
  const isStrUndefined = includeStr && target === 'undefined';
  
  return isRawUndefined || isStrUndefined;
}
export default{
		isLogin,
		placeholderPic,
		platForm,
		isWx,
		clearLogin,
		networkError,
		isCard,
		isToday,
		getSign,
		calculateSign,
		randStr,
		getTime,
		debounce,
		throttle,
		permissions,
		menuBtns,
		menuTabs,
		noManyMsg,
		mergeAndDistinct,
		findMenuId,
		findDuplicates,
		getNamesByIds,
		validateStrictNumber,
		roundAndCeilIfDecimal,
		strictPositiveIntegerValidator,
		isUndefined,
}